import { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, query, orderBy, onSnapshot, addDoc, serverTimestamp, getDoc, doc } from 'firebase/firestore';

const useChat = (conversationId) => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log('useChat: Effect triggered with conversationId:', conversationId);
    if (!conversationId) {
      console.log('useChat: No conversationId provided, returning');
      setLoading(false);
      return;
    }

    const messagesRef = collection(db, 'conversations', conversationId, 'messages');
    const q = query(messagesRef, orderBy('timestamp', 'asc'));

    console.log('useChat: Setting up onSnapshot listener');
    const unsubscribe = onSnapshot(q, async (querySnapshot) => {
      console.log('useChat: onSnapshot triggered');
      const fetchedMessages = await Promise.all(querySnapshot.docs.map(async (docSnapshot) => {
        const data = docSnapshot.data();
        let senderName = data.senderName;
        if (!senderName) {
          const userDocRef = doc(db, 'users', data.senderId);
          const userDoc = await getDoc(userDocRef);
          senderName = userDoc.exists() ? (userDoc.data().displayName || 'Anonymous') : 'Unknown User';
        }
        return {
          id: docSnapshot.id,
          ...data,
          senderName
        };
      }));
      console.log('useChat: Fetched messages:', fetchedMessages);
      setMessages(fetchedMessages);
      setLoading(false);
      setError(null);
    }, (err) => {
      console.error('useChat: Error in onSnapshot:', err);
      setError(err.message);
      setLoading(false);
    });

    return () => {
      console.log('useChat: Unsubscribing from onSnapshot');
      unsubscribe();
    };
  }, [conversationId]);

  const sendMessage = async (content, senderId, senderName) => {
    console.log('useChat: Sending message:', { content, senderId, senderName, conversationId });
    try {
      const messagesRef = collection(db, 'conversations', conversationId, 'messages');
      const docRef = await addDoc(messagesRef, {
        content,
        senderId,
        senderName,
        timestamp: serverTimestamp()
      });
      console.log('useChat: Message sent successfully, docRef:', docRef.id);
    } catch (err) {
      console.error('useChat: Error sending message:', err);
      setError(err.message);
    }
  };

  return { messages, loading, error, sendMessage };
};

export default useChat;
